/**
 * Spacing tokens in pixels
 * @see [Figma Spacing](https://www.figma.com/design/56sl8nzEsswtU7qNn6drvG/Kos-v1?node-id=6-145)
 */
export const spacing = {
  // Zero
  '0': 0,

  // Small values
  '0.5': 2,
  '1': 4,
  '1.5': 6,
  '2': 8,
  '2.5': 10,
  '3': 12,

  // Medium values
  '3.5': 14,
  '4': 16,
  '4.5': 18,
  '5': 20,
  '6': 24,
  '7': 28,
  '8': 32,
  '9': 36,
  '10': 40,
  '11': 44,
  '12': 48,
  '14': 56,
  '16': 64,
  '20': 80,
  '24': 96,
  '28': 112,

  // Large values
  '32': 128,
  '36': 144,
  '40': 160,
  '44': 176,
  '48': 192,
  '52': 208,
  '56': 224,
  '60': 240,
  '64': 256,
  '72': 288,
  '80': 320,
  '96': 384,
};
